import React from 'react';
import Typography from '../Text/Typography';
import Button from '../Button/Button';
import emptyCabinetImage from '../../assets/empty_cabinet.png';
import './EmptyCabinetState.css';

export interface EmptyCabinetStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: string;
  className?: string;
}

const EmptyCabinetState: React.FC<EmptyCabinetStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  actionIcon = 'add',
  className = '',
}) => {
  return (
    <div className={`empty-cabinet-state ${className}`.trim()}>
      <img
        src={emptyCabinetImage}
        alt=""
        className="empty-cabinet-state-image"
        aria-hidden
      />
      <Typography variant="h3" className="empty-cabinet-state-title">
        {title}
      </Typography>
      {description ? (
        <Typography variant="body" className="empty-cabinet-state-description">
          {description}
        </Typography>
      ) : null}
      {actionLabel && onAction ? (
        <Button
          variant="primary"
          onClick={onAction}
          icon={{ name: actionIcon, size: 'small' }}
          className="empty-cabinet-state-action"
        >
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
};

export default EmptyCabinetState;
